var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slideMode-error"},[_c('div',{staticClass:"slideMode-error_body"},[_vm._v(_vm._s(_vm.errorReason || 'error'))]),_c('SlideControl',{attrs:{"option":_vm.option,"page":0,"pages":[''],"disable":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }